import type { IconSvgObject } from './types';

const BorderLeft02Icon: IconSvgObject = [
  ["path", { d: "M6.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5H6.5M10 2.5H14M10 21.5H14M17.75 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V17.75M21.5 10V14M21.5 6.25V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H17.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default BorderLeft02Icon;
